"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = FixedTop;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _newMenu = _interopRequireDefault(require("../newMenu"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

require("./styles/index.less");

var styles = {
  "root": "meepshop-meep-ui__fixedTop-index__root"
};

function FixedTop(_ref) {
  var menu = _ref.menu;
  var headerRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (!headerRef.current) return function () {};
    var observer = new ResizeObserver(function (_ref2) {
      var _ref3 = (0, _slicedToArray2["default"])(_ref2, 1),
          entry = _ref3[0];

      var height = entry.contentRect.height;
      document.documentElement.style.setProperty('--fixed-top-height', "".concat(height, "px"));
    });
    observer.observe(headerRef.current);
    return function () {
      observer.disconnect();
      document.documentElement.style.setProperty('--fixed-top-height', '0px');
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement("header", {
    ref: headerRef,
    className: styles.root
  }, menu ? /*#__PURE__*/_react["default"].createElement(_newMenu["default"], {
    id: "menu-fixedTop",
    menu: menu
  }) : null);
}